
<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">{{ this.$route.meta.title }}
        <div class="card-header-actions">
          <!-- <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button> -->
          <button class="btn btn-primary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>

        <b-col>
          <b-input-group>
            <b-input-group-prepend><label>Periode Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Search</label></b-input-group-prepend>
            <b-form-input v-model="filter.tgl1"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group>
            <b-input-group-prepend><label>Project Type</label></b-input-group-prepend>
            <b-form-select v-model="filter.pjxjobtype" :plain="true" :options="filtertypes"></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Project Name</label></b-input-group-prepend>
            <b-form-input v-model="filter.pjxname"></b-form-input>
            <div class="float-right">
              <b-button class="btn btn-success ml-3 mr-1" @click="refresh()"> <i class="fa fa-refresh"></i> Apply
                Filter</b-button>
              <b-button class="btn btn-secondary mr-1" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear
                Filter</b-button>
            </div>
          </b-input-group>

        </b-col>
      </b-row>

      <b-table class="mb-0" ref="table" outlined responsive hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" @row-clicked="rowClicked" :key="tblData.limit" show-empty>
        <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" 
         toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-success"></i>
          </template>
          <!-- <b-dropdown-item @click="rowEdit(data.item)" href="#"  :disabled="data.item.poststatus==1" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  :disabled="data.item.poststatus==1" style="padding:0 !important;"> Delete</b-dropdown-item> -->
          <b-dropdown-item @click="rowConfirmPosting(data.item)" :disabled="data.item.poststatus==1"> Posting</b-dropdown-item>
          <!-- <b-dropdown-item @click="rowConfirmUnPosting(data.item)" :disabled="data.item.poststatus!=1"> Un-Posting</b-dropdown-item> -->
        </b-dropdown>
      </template>       
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
        <template v-slot:cell(trx_amount)="data">
          <span>{{ data.item.trx_amount | numFormat('0,0.00') }}</span>
        </template>
        <template v-slot:cell(payment_amount)="data">
          <span>{{ data.item.payment_amount | numFormat('0,0.00') }}</span>
        </template>

        <template v-slot:cell(cumulative_payment_amount)="data">
          <span>{{ data.item.cumulative_payment_amount | numFormat('0,0.00') }}</span>
        </template>

        <template v-slot:cell(created_at)="data">
          <span>{{ data.item.created_at | moment('DD-MMM-YYYY HH:mm') }}</span>
        </template>
        <template v-slot:cell(datetime_payment)="data">
          <span>{{ data.item.datetime_payment | moment('DD-MMM-YYYY HH:mm') }}</span>
        </template>


        <!-- <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template> -->
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span> <span v-else>{{
      tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group>
            <b-input-group-prepend><span class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
            <b-form-select :options="[10, 15, 20, 25, 30, 35, 40, 45, 50]" :plain="true" v-model="tblData.limit"
              size="sm" style="max-width:80px;" />
          </b-input-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit"
            v-model="tblData.page"></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Project - Add/Edit Form
          </div>
          <b-input-group>
            <b-input-group-prepend><label>Customer Name</label></b-input-group-prepend>
            <div class="form-control-static">{{ frmdata.customer_name }}</div>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Customer Email</label></b-input-group-prepend>
            <div class="form-control-static">{{ frmdata.customer_email }}</div>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Customer Phone</label></b-input-group-prepend>
            <div class="form-control-static">{{ frmdata.customer_phone }}</div>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Finance Account</label></b-input-group-prepend>
            <b-form-input readonly v-model="frmdata.namabank"
              @keyup.13.native="lkuBankaccountShow = true"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuBankaccountShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Billing Type</label></b-input-group-prepend>
            <b-form-select v-model="frmdata.billing_type" :plain="true" :options="billingTypeOpt"></b-form-select>
          </b-input-group>
          <b-input-group>
            <div class="form-control-static" style="margin-left:151px;">{{ frmdata.billing_type_desc }}</div>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
            <my-number class="form-control text-right" v-model="frmdata.trx_amount" :precision="0"></my-number>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend><label>Virtual Account</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.virtual_account"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Datetime Expired</label></b-input-group-prepend>
            <date-picker v-model="frmdata.datetime_expired" type="datetime"></date-picker>

          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.description"></b-form-input>
          </b-input-group>

          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()"> <i class="fa fa-close"></i> Close
              Form</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account"
      :centered="true">
      <lku-bankaccount @click="onSelectLkuBankaccount" :isbank="bankOnly" :key="bankOnly"></lku-bankaccount>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>

<style lang="scss">
.input-group {
  padding-bottom: 2px;

  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 100px;
    }
  }
}
</style>


<script>
import moment from 'moment'
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import ecollection from "../../apis/ecollection"
import lkuCustomer from "../lookup/lkuCustomer";
import lkuBankaccount from "../lookup/lkuBankaccount";
import myNumber from "../../components/my-number.vue";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: { lkuCustomer, lkuBankaccount, datePicker, myNumber,Loading },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      nasabahkey: { required },
      pinjamankey: { required },
      trx_amount: { required },
      billing_type: { required },
      customer_name: { required },
    },
  },
  data() {
    return {
      isLoading:false,
      showDelConfirm: false,
      showList: true,
      showForm: false,
      lkuCustomerShow: false,
      bankOnly: 1,
      lkuBankaccountShow: false,
      frmdata: {
        trx_id: '',
        trx_amount: 0,
        billing_type: 'n',
        billing_type_desc: '',
        customer_name: '',
        customer_email: '',
        customer_phone: '',
        virtual_account: '',
        datetime_expired: '',
        description: '',
        nasabahkey: '',
        pinjamankey: '',
        pjxkey: '',
      },
      types: [], filtertypes: [{ value: '', text: '--ALL--' }],
      studiolives: [], studiotapes: [], spotrates: [],
      tblData: {
        tablename: 'e-collection-payment',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        tgl1: '', tgl2: ''
      },
      billingTypeOpt: [
        { value: 'o', text: 'Open payment', description: 'invoice/billing can be paid multiple times as long as it is still active' },
        {
          value: 'c', text: 'Fixed payment', description: 'invoice/billing should be paid with exactly the same amount as requested.'
        },
        { value: 'i', text: 'Installment/partial payment', description: 'nvoice/billing can be paid multiple times as long as paid amount is less than the requested amount and still active' },
        { value: 'm', text: 'Minimum payment', description: 'invoice/billing can be paid with greater than or equal to the requested amount.' },
        { value: 'n', text: 'Open minimum payment', description: 'invoice/billing can be paid greater than or equal to the requested amount multiple times as long as it is still active.' },
        { value: 'x', text: 'Open maximum payment', description: 'invoice/billing can be paid less than or equal to the requested amount multiple times as long as it is still active.' },
      ],
      filter: { pjxname: '', pjxjobtype: '' }
    };
  },
  mounted() {
    this.tblData.tgl1 = moment(this.timeServer).startOf('month').format('YYYY-MM-DD');
    this.tblData.tgl2 = moment(this.timeServer).endOf('month').format('YYYY-MM-DD');
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "Action",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "datetime_payment",
          label: "Payment Time",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "payment_ntb",
          label: "Reference No",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "trx_id",
          label: "Billing ID",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "customer_name",
          label: "Customer Name",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "virtual_account",
          label: "VA Number",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "trx_amount",
          label: "Billing Amount",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "payment_amount",
          label: "Payment Amount",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true
        },

        {
          key: "cumulative_payment_amount",
          label: "Cumulative Payment",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "paymno",
          label: "Payment No",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "nomor",
          label: "Bank No",
          tdClass: "text-right",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "created_by",
          label: "Created By",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "created_at",
          label: "Created At",
          thClass: "text-center",
          sortable: true
        },
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    timeServer() {
      const { user, timeServer } = this.$store.state;
      return timeServer[user.compcode]
    },
  },
  watch: {
    'frmdata.billing_type'(val) {
      let obj = this.billingTypeOpt.find(x => x.value == val)
      this.frmdata.billing_type_desc = obj.description
    }
  },
  created: async function () {
    try {
      const [a] = await Promise.all([
        crud.list({
          tablename: 'project',
          page: 1,
          limit: 1000,
          total: 0,
          sortBy: null,
          sortDesc: true
        })
      ]);
      this.filtertypes = a.map(dt => {
        dt.value = dt.pjxkey
        dt.text = `${dt.pjxcode} - ${dt.pjxname}`
        return dt;
      })
    } catch (error) {

    }
  },
  methods: {
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // this.tblData.customQuery = '';
      let str = '';
      if (this.tblData.tgl1) {
        str += str ? '&' : '';
        str += `raw=(date_payment between '${encodeURIComponent(moment(this.tblData.tgl1).format('YYYY-MM-DD'))}' and '${encodeURIComponent(moment(this.tblData.tgl2).format('YYYY-MM-DD'))}' )`;
      }
      this.tblData.customQuery = str;
      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.filter.pjxname = '';
      this.filter.pjxjobtype = '';
      this.refresh();
    },
    onSelectLkuBankaccount(_selected) {
      this.model.kodebank = _selected.kode;
      this.model.matauang = _selected.matauang;
      this.model.namabank = _selected.namabank;
      this.model.nomorrek = _selected.nomorrek;
      this.model.isbank = _selected.isbank;
      this.lkuBankaccountShow = false;
    },
    add: function (data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = '';
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function (data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = '';
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.pjxkey;
      this.showForm = true;
      this.showList = false;

    },
    save: async function (callback) {
      if (this.invalidFormdata) {
        console.log('validation : ', this.$v.frmdata);
        console.log('frmdata : ', this.frmdata);
        toastr.error('Please fill the form correctly.', 'ERROR MESSAGE');
      } else {
        try {
          const data = await ecollection.save(this.frmdata)
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function () {
      await crud.remove({ tablename: 'project', key: this.model.pjxkey });
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
    },
    rowConfirmPosting: async function (record) {
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();

      this.$bvModal.msgBoxConfirm('Please confirm that you want to POSTING.', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(async value => {
          if (value) {
            try {
              this.isLoading = true;
              await ecollection.savePaymentVa(this.model)
              this.refresh()
              this.isLoading = false;
            } catch (error) {
              this.isLoading = false;
            }
          }
        })
        .catch(err => {
          this.isLoading = false;
          // An error occurred
        })

    },
    onSelectLkuCustomer: async function (_selected) {
      this.frmdata.custinfo = _selected.CustName.trim() + ' | ' + _selected.CustCode.trim();
      this.frmdata.cust_id = _selected.customer_id;
      this.lkuCustomerShow = false;
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push("home");
    },
  }
};
</script>
